const { getProperty } = require('../util/PropertyGetter');

const isFeatureForcedConstructor = (recipeSet, req) => (key) => {
  const FEATURE_FORCE_PARAMETER = 'pdp_exp';
  const queryParamValues = getProperty(req, `query.${FEATURE_FORCE_PARAMETER}`);

  if (queryParamValues && typeof queryParamValues === 'string') {
    return queryParamValues.toLowerCase().split(',').includes(key);
  } else if (recipeSet && typeof recipeSet.has === 'function') {
    return recipeSet.has(key);
  }

  return false;
};

function getFeatureEligibleFlags(data) {
  const uiKillSwitches = getProperty(data, 'uiKillSwitches', {});
  const product = getProperty(data, 'product', {});
  const flags = getProperty(data, 'product.detail.flags', {});
  const recipeSet = data.recipeIdSet instanceof Set ? data.recipeIdSet : new Set();
  const desktop = getProperty(data, 'desktop', false);
  const tablet = getProperty(data, 'tablet', false);
  const phone = getProperty(data, 'phone', false);
  const isIShip = getProperty(data, 'isIShip', false);
  const isRegistryMode = getProperty(data, 'isRegistryMode', false);
  const isLuxury = flags.chanel || flags.hermes;
  const isAvailable = !!getProperty(product, 'availability.available');
  const departmentId = getProperty(data, 'product.department.departmentId', 0);
  const isFeatureForced = isFeatureForcedConstructor(recipeSet, data.req);

  const priceExpEligible = uiKillSwitches.isPriceExpEnabled && !isIShip && !isRegistryMode;
  const googleAdEligible = !!(uiKillSwitches.googleDisplayAdEnabled && !isIShip && !isRegistryMode && !isLuxury && !flags.finishLine);

  const featureEligible = {
    accordions: !flags.masterProduct,
    ccfp: uiKillSwitches.ccfpEnabled && getProperty(data, 'product.ccfp.ccfpEligible', false) && !flags.masterProduct && !!getProperty(data, `product.ccfp.chargePlanPDPDeptDetails[${departmentId}].length`, false) && !flags.consolidatedProductComplex,
    colorwayOffers: uiKillSwitches.isUpcLevelPromoBadgingEnabled && !flags.masterProduct && !flags.gwpExperienceEnabled && !flags.giftCard,
    desktopBVApiTrt2Enabled: desktop && uiKillSwitches.phase2DesktopBVReviewsApiEnabled && recipeSet.has('653-22'),
    dimensionsBullets: !!getProperty(product, 'detail.dimensionsBulletText') && !flags.masterProduct && isAvailable && !flags.giftCard && !flags.gwpExperienceEnabled,
    findation: uiKillSwitches.isFindationEnabled && flags.isFindationEnabled && !isLuxury && !flags.masterProduct,
    googleAdBottom: googleAdEligible && !phone && !flags.gwpExperienceEnabled,
    instructionsAccordion: flags.gwpExperienceEnabled,
    klarna: uiKillSwitches.klarnaPaymentEnabled && flags.klarnaEligible && !isIShip && !flags.masterProduct,
    materialsAndCare: !!getProperty(product, 'detail.materialsAndCare') && !flags.masterProduct && isAvailable && !flags.giftCard && !flags.gwpExperienceEnabled,
    popularRelatedSearches: !!product.seotags && !isLuxury && !isIShip && !flags.giftCard,
    priceExpTrt2: (priceExpEligible && recipeSet.has('677-22')) || isFeatureForced('price2'),
    priceExpTrt3: (priceExpEligible && recipeSet.has('677-23')) || isFeatureForced('price3'),
    productDetailsStandAlone: flags.masterProduct,
    reviewsSummary: !!(!isIShip || getProperty(data, 'product.detail.reviewStatistics.aggregate')) && !flags.gwpExperienceEnabled,
    reviewsSummaryAccordion: !!getProperty(product, 'detail.reviewStatistics') && !flags.masterProduct && !flags.giftCard && !flags.gwpExperienceEnabled,
    shippingDetails: !flags.masterProduct,
    shopByDeptAccordion: !isIShip && !isRegistryMode,
    socialShareIcons: !flags.giftCard,
    specialOffersAccordion: isAvailable && !flags.gwpExperienceEnabled && !flags.giftCard,
    termsConditionsAccordion: flags.gwpExperienceEnabled,
  };

  const desktopBVApiTrt1Enabled = desktop && uiKillSwitches.phase2DesktopBVReviewsApiEnabled && recipeSet.has('653-21');
  const mobileBVApiTrt1Enabled = (phone || tablet) && uiKillSwitches.phase2MobileBVReviewsApiEnabled && recipeSet.has('655-21');

  const priceExpTrt1 = (priceExpEligible && recipeSet.has('677-21')) || isFeatureForced('price');
  const priceExp = priceExpTrt1 || featureEligible.priceExpTrt2 || featureEligible.priceExpTrt3;

  Object.assign(featureEligible, {
    creditFinance: featureEligible.klarna || featureEligible.ccfp,
    macysLoveGalleryAccordion: uiKillSwitches.beautyCuralateEnabled && flags.beauty && !isLuxury &&
      !flags.gwpExperienceEnabled && !flags.masterProduct && !flags.giftCard &&
      !(googleAdEligible && !phone),
    showNonHostedBV: desktopBVApiTrt1Enabled || featureEligible.desktopBVApiTrt2Enabled || mobileBVApiTrt1Enabled,
    priceExp,
    priceExpPrice: priceExp && !flags.masterProduct,
  });

  return featureEligible;
}

module.exports = {
  getFeatureEligibleFlags,
};



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/util/FeatureEligible.js